import { useContext } from 'react';
import Card from 'react-bootstrap/Card';
import { Route, Switch } from 'react-router-dom';
import AppContext from '../../AppContext';
import AppNav from '../AppNav';
import { AppHeaderTitle } from './AppHeaderTitle';
import { TopRightMenu } from './TopRightMenu';

const AppHeader = () => {
  const { user } = useContext(AppContext);
  return (
    <Switch>
      <Route exact path="/happy-island" key={'happy-island'} />
      <Route
        path="/"
        key="any"
        render={() => (
          <header>
            <Card>
              <Card.Body>
                <AppHeaderTitle />
                <div className="float-end">
                  <TopRightMenu />
                </div>
              </Card.Body>
            </Card>
            {user && (
              <Card className="mt-1">
                <Card.Body
                  style={{
                    paddingBottom: '0.25rem',
                    paddingTop: '0.25rem',
                  }}
                >
                  <AppNav />
                </Card.Body>
              </Card>
            )}
          </header>
        )}
      />
    </Switch>
  );
};

export default AppHeader;
